import { Input, Label } from "@monsterindia/global-ui-components";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";

import { API_ENDPOINT } from "../../../constants/appConstant";
import {
  DefaultLanguageData,
  ExperienceMonthsDropdownOptionsData,
  ExperienceYearsDropdownOptionsData,
  GenderDropdownOptionsData,
} from "../../../constants/basicDetailsApop";
import { useNetwork } from "../../../hooks/useNetwork";
import {
  CheckboxOptionType,
  DropdownOptionType,
  MasterDataType,
} from "../../../types";
import { getSiteProps } from "../../../utils/siteProps";
import { ALPAHBET_REGEX } from "../../../validations/Regex";
import { PillController, SingleDropDownController } from "../../controllers";
import { ActionButtonContainer } from "../common/ActionButtonContainer";
import { ApplyForJobCard } from "../common/ApplyForJobCard";
import { Heading } from "../common/Heading";
import LanguageCardContainer from "../common/LanguageCard";
import { LanguagesType } from "../common/LanguageCard/Language.types";
import { LinkedInConsent } from "../common/Linkedin/LinkedinConsent";
import { LinkedinURL } from "../common/Linkedin/LinkedinURL";
import {
  BasicDetailsUIProps,
  CityDropdownType,
  NationalityDropdownType,
} from "./BasicDetails.types";
import "./styles.css";

export const BasicDetailsUI = ({
  prefilledData,
  closeApop,
  backBtnClickHandler,
  onSubmit,
  isSubmitAPILoading,
  flowType,
  jobData,
}: BasicDetailsUIProps) => {
  const {
    handleSubmit,
    getValues,
    formState: { errors },
    control,
    register,
    setValue,
    setError,
    clearErrors,
  } = useForm();
  const defaultLanguageData: LanguagesType = {
    language: null,
    proficiency: null,
    read: 0,
    write: 0,
    speak: 0,
  };

  const [cityData, setCityData] = useState<CheckboxOptionType[] | null>([]);
  const [nationalityData, setNationalityData] = useState<
    CheckboxOptionType[] | null
  >([]);
  const [workAuthorizationData, setWorkAuthorizationData] = useState<
    CheckboxOptionType[] | null
  >([]);
  const [isOtherCity, setIsOtherCity] = useState(false);
  const [isCityOtherThenIndia, setIsCityOtherThenIndia] = useState(false);
  const [showWorkAuthorization, setShowWorkAuthorization] = useState(false);
  const [country, setCountry] = useState("");
  const [genderOptions, setGenderOptions] = useState<
    DropdownOptionType[] | null
  >(GenderDropdownOptionsData);
  const [showLinkedinURL, setShowLinkedinURL] = useState(true);
  // const [showLinkedinConsent, setShowLinkedinConsent] = useState(true);
  // const [isAutoUpdateChecked, setIsAutoUpdateChecked] = useState(false);
  const [isDropdownOptionLoading, setIsDropdownOptionLoading] = useState(false);
  const [languageData, setLanguageData] = useState<LanguagesType[]>([
    defaultLanguageData,
  ]);
  const { fetchData: fetchAPI } = useNetwork();

  const siteConfig = getSiteProps(window.location.hostname);
  const [countryIsoCode, setCountryIsoCode] = useState<string>("IN");
  const prefilledDataAny = prefilledData as any;
  const languagePrefillData =
    prefilledDataAny?.languages ??
    prefilledDataAny?.languageSection?.languages ??
    prefilledDataAny?.basicDetailsPrefill?.additionalPersonalDetail?.languages;
  const hasPrefilledLanguages =
    Array.isArray(languagePrefillData) &&
    languagePrefillData.some((language: any) => {
      const languageValue = language?.language ?? language?.name;
      return !!(
        languageValue?.id ||
        languageValue?.text ||
        languageValue?.name
      );
    });

  const prefillDataHelper = async (prefillData: any) => {
    const { basicDetailsPrefill, linkedInResponse } = prefillData;
    if (basicDetailsPrefill) {
      setValue("name", basicDetailsPrefill?.fullName?.slice(0, 30) ?? "");

      // Gender
      if (siteConfig?.site_map !== "monstersingapore") {
        const updatedGenderData = GenderDropdownOptionsData.map((gender) => {
          if (
            gender.text ===
            basicDetailsPrefill?.additionalPersonalDetail?.gender?.text
          ) {
            return {
              ...gender,
              selected: true,
            };
          }
          return gender;
        });

        setGenderOptions(updatedGenderData);
        setValue("gender", updatedGenderData);
      }

      // Experience
      if (basicDetailsPrefill?.experienceLevel === "FRESHER") {
        setValue("years", {
          id: 0,
          text: "0",
        });
        setValue("months", {
          id: 0,
          text: "0",
        });
      } else {
        setValue("years", {
          id:
            basicDetailsPrefill?.additionalPersonalDetail?.experience?.years ??
            "",
          text:
            basicDetailsPrefill?.additionalPersonalDetail?.experience?.years ??
            "",
        });
        setValue("months", {
          id:
            basicDetailsPrefill?.additionalPersonalDetail?.experience?.months ??
            "",
          text:
            basicDetailsPrefill?.additionalPersonalDetail?.experience?.months ??
            "",
        });
      }

      // City
      if (basicDetailsPrefill?.additionalPersonalDetail?.currentLocation) {
        // get city data from master api
        const fetchCityData = await cityDropdownOptionsData(
          basicDetailsPrefill?.additionalPersonalDetail?.currentLocation?.text,
        );

        const fetchedCountry =
          fetchCityData && fetchCityData?.length > 0
            ? fetchCityData[0].country
            : "";

        const fetchedCountryUUID =
          fetchCityData && fetchCityData?.length > 0
            ? fetchCityData[0].countryUUID
            : "";

        setValue("city", {
          id:
            basicDetailsPrefill?.additionalPersonalDetail?.currentLocation
              ?.id ?? "",
          text:
            basicDetailsPrefill?.additionalPersonalDetail?.currentLocation
              ?.text ?? "",
          country: fetchedCountry,
          countryUUID: fetchedCountryUUID,
        });

        setCountryIsoCode(
          basicDetailsPrefill?.additionalPersonalDetail?.currentLocation
            ?.extraInfo?.countryIsoCode ?? "IN",
        );

        if (
          basicDetailsPrefill?.additionalPersonalDetail?.currentLocation
            ?.text &&
          basicDetailsPrefill?.additionalPersonalDetail?.currentLocation?.text.includes(
            "Other",
          )
        ) {
          setIsOtherCity(true);
          setValue(
            "otherCity",
            basicDetailsPrefill?.additionalPersonalDetail?.currentLocation
              ?.otherText ?? "",
          );
        }

        setCountry(fetchedCountry);

        if (
          fetchedCountry !== "India" ||
          (basicDetailsPrefill?.additionalPersonalDetail?.currentLocation
            ?.text &&
            basicDetailsPrefill?.additionalPersonalDetail?.currentLocation?.text.includes(
              "Other",
            ))
        ) {
          setIsCityOtherThenIndia(true);
        }

        if (
          siteConfig?.site_map !== "rexmonster" ||
          fetchedCountry !== "India" ||
          (basicDetailsPrefill?.additionalPersonalDetail?.currentLocation
            ?.text &&
            basicDetailsPrefill?.additionalPersonalDetail?.currentLocation?.text.includes(
              "Other",
            )) ||
          basicDetailsPrefill?.additionalPersonalDetail?.nationality?.text
        ) {
          const fetchNationalityData = await nationalityDropdownOptionsData(
            basicDetailsPrefill?.nationality?.text,
          );

          const fetchedNationalityCountryUUID =
            fetchNationalityData && fetchNationalityData?.length > 0
              ? fetchNationalityData[0].countryUUID
              : "";

          setValue("nationality", {
            id: basicDetailsPrefill?.nationality?.id ?? "",
            text: basicDetailsPrefill?.nationality?.text ?? "",
            countryUUID: fetchedNationalityCountryUUID,
          });

          if (
            fetchedNationalityCountryUUID !== getValues("city")?.countryUUID ||
            basicDetailsPrefill?.additionalPersonalDetail?.workVisaType?.text
          ) {
            setShowWorkAuthorization(true);

            if (flowType !== "PROFILE_NUDGE") {
              setValue("workAuthorization", {
                id:
                  basicDetailsPrefill?.additionalPersonalDetail?.workVisaType
                    ?.id ?? "",
                text:
                  basicDetailsPrefill?.additionalPersonalDetail?.workVisaType
                    ?.text ?? "",
                countryUUID: fetchedNationalityCountryUUID,
              });
            }
          } else {
            setShowWorkAuthorization(false);
          }
        }
      }
    }

    if (linkedInResponse) {
      const { linkedInConsent, url } = linkedInResponse;

      if (url) {
        setValue("linkedin", url);
        setShowLinkedinURL(false);
      } else {
        setShowLinkedinURL(true);
      }
      // if (linkedInConsent === false || linkedInConsent === true) {
      //   setValue("isToggled", linkedInConsent);
      //   setShowLinkedinConsent(false);
      // } else {
      //   setShowLinkedinConsent(true);
      //   setValue("isToggled", true);
      //   setIsAutoUpdateChecked(true);
      // }
    }

    if (Array.isArray(languagePrefillData) && languagePrefillData.length > 0) {
      const normalizedLanguages: LanguagesType[] = languagePrefillData.map(
        (language: any) => {
          const languageValue = language?.language ?? language?.name;
          const proficiencyValue =
            language?.proficiency ?? language?.proficiencyLevel;

          return {
            id: language?.id ?? null,
            language: languageValue
              ? {
                  id: languageValue?.id ?? languageValue?.uuid ?? "",
                  text: languageValue?.text ?? languageValue?.name ?? "",
                }
              : null,
            proficiency: proficiencyValue
              ? {
                  id: proficiencyValue?.id ?? proficiencyValue?.uuid ?? "",
                  text: proficiencyValue?.text ?? proficiencyValue?.name ?? "",
                }
              : null,
            read: language?.read ? 1 : 0,
            write: language?.write ? 1 : 0,
            speak: language?.speak ? 1 : 0,
          };
        },
      );

      setLanguageData(normalizedLanguages);

      normalizedLanguages.forEach((language, index) => {
        setValue(`language-${index}`, language?.language ?? null);
        setValue(`proficiency-${index}`, language?.proficiency ?? null);

        const communicationValues: string[] = [];
        if (language?.read) communicationValues.push("read");
        if (language?.write) communicationValues.push("write");
        if (language?.speak) communicationValues.push("speak");

        setValue(`communication-${index}`, communicationValues);
      });
    }
    // else {
    // setShowLinkedinURL(true);
    // setShowLinkedinConsent(true);
    // setValue("isToggled", true);
    // setIsAutoUpdateChecked(true);
    // }
  };

  useEffect(() => {
    if (prefilledData) {
      prefillDataHelper(prefilledData);
    }
  }, [prefilledData]);

  const cityDropdownOptionsData = async (location: string) => {
    setIsDropdownOptionLoading(true);
    const cityDataResponse = await fetchAPI(
      `${API_ENDPOINT().seekerProfile.masterDataMiddleware}?type=location&name=${location}`,
      "GET",
    );

    const masterCityData = (cityDataResponse?.data as any)
      ?.data as MasterDataType[];
    const updatedCityData =
      masterCityData && masterCityData.length > 0
        ? masterCityData.map((city) => {
            return {
              value: city.name,
              id: city.uuid,
              text: city.name,
              country: city?.country?.name ?? "",
              countryUUID: city?.country?.uuid ?? "",
              countryIsoCode: city?.country?.isoCode ?? "",
            };
          })
        : null;

    setIsDropdownOptionLoading(false);
    setCityData(updatedCityData);
    return updatedCityData;
  };

  const nationalityDropdownOptionsData = async (nationality: string) => {
    setIsDropdownOptionLoading(true);
    const nationalityDataResponse = await fetchAPI(
      `${API_ENDPOINT().seekerProfile.masterDataMiddleware}?type=Nationality&name=${nationality}`,
      "GET",
    );

    const masterNationalityData = (nationalityDataResponse?.data as any)
      ?.data as MasterDataType[];
    const updatedNationalityData =
      masterNationalityData && masterNationalityData.length > 0
        ? masterNationalityData.map((nationality) => {
            return {
              value: nationality.name,
              id: nationality.uuid,
              text: nationality.name,
              countryUUID: nationality?.country?.uuid ?? "",
            };
          })
        : null;

    setIsDropdownOptionLoading(true);
    setNationalityData(updatedNationalityData);
    return updatedNationalityData;
  };

  const workAuthorizationDropdownOptionsData = async (
    countryIsoCode: string,
  ) => {
    setIsDropdownOptionLoading(true);
    const workAuthorizationDataResponse = await fetchAPI(
      `${API_ENDPOINT().seekerProfile.masterDataMiddleware}?type=VISA_TYPE&countryIsoCode=${countryIsoCode}`,
      "GET",
    );
    const masterWorkAuthorizationData = (
      workAuthorizationDataResponse?.data as any
    )?.data as MasterDataType[];
    const updatedWorkAuthorizationData =
      masterWorkAuthorizationData && masterWorkAuthorizationData.length > 0
        ? masterWorkAuthorizationData.map((workAuthorization) => {
            return {
              value: workAuthorization.name,
              id: workAuthorization.uuid,
              text: workAuthorization.name,
            };
          })
        : null;

    if (
      countryIsoCode !== "SG" &&
      updatedWorkAuthorizationData &&
      updatedWorkAuthorizationData.length > 0
    ) {
      updatedWorkAuthorizationData.push({
        value: "I don't have work authorization",
        id: "0",
        text: "I don't have work authorization",
      });
    }

    setIsDropdownOptionLoading(false);
    setWorkAuthorizationData(updatedWorkAuthorizationData);
    return updatedWorkAuthorizationData;
  };

  const addAnotherLanguageDataHandler = () => {
    setLanguageData((prev) => [...(prev ?? []), DefaultLanguageData]);
  };

  const deleteLanguageDataHandler = (index: number) => {
    if (languageData && languageData.length > 0) {
      // remove language data from form
      clearErrors([
        `language-${index}`,
        `proficiency-${index}`,
        `communication-${index}`,
      ]);
      // shift the data up
      if (languageData) {
        for (let i = index; i < languageData.length - 1; i++) {
          setValue(`language-${i}`, getValues(`language-${i + 1}`));
          setValue(`proficiency-${i}`, getValues(`proficiency-${i + 1}`));
          setValue(`communication-${i}`, getValues(`communication-${i + 1}`));
        }
      }

      // remove the last data
      setValue(`language-${languageData?.length - 1}`, null);
      setValue(`proficiency-${languageData?.length - 1}`, null);
      setValue(`communication-${languageData?.length - 1}`, null);

      setLanguageData((prev) => {
        if (prev) {
          const updatedData = prev.filter((_, idx) => idx !== index);
          return updatedData;
        }
        return [defaultLanguageData];
      });
    }
  };

  const onSubmitWrapper = (data: any) => {
    const finalLanguageData: LanguagesType[] = [];
    if (
      siteConfig?.site_map !== "rexmonster" &&
      languageData &&
      languageData.length > 0
    ) {
      languageData.forEach((_, index) => {
        finalLanguageData[index] = {
          language: getValues(`language-${index}`),
          proficiency: getValues(`proficiency-${index}`),
          read: getValues(`communication-${index}`)
            ? getValues(`communication-${index}`)?.includes("read")
              ? 1
              : 0
            : 0,
          write: getValues(`communication-${index}`)
            ? getValues(`communication-${index}`)?.includes("write")
              ? 1
              : 0
            : 0,
          speak: getValues(`communication-${index}`)
            ? getValues(`communication-${index}`)?.includes("speak")
              ? 1
              : 0
            : 0,
        };
      });
    }

    onSubmit(data, isOtherCity, siteConfig?.site_map ?? "", finalLanguageData);
  };

  useEffect(() => {
    if (showWorkAuthorization && countryIsoCode) {
      workAuthorizationDropdownOptionsData(countryIsoCode);
    }
  }, [showWorkAuthorization, countryIsoCode]);

  return (
    <>
      {flowType !== "EDIT_PROFILE" && (
        <Heading
          headingText="Basic Details"
          isMobile={window.innerWidth < 768}
          onCloseBtnClickHandler={() => {
            closeApop();
          }}
        />
      )}

      {flowType === "PROFILE_NUDGE" && jobData ? (
        <div className="l1-mt-14 l1-mb-4">
          <ApplyForJobCard
            jobId={jobData.jobId}
            jobTitle={jobData.jobTitle}
            companyName={jobData.companyName}
            companyLogoUrl={jobData.companyLogoUrl}
          />
        </div>
      ) : null}

      <form
        className={`l1-relative l1-flex l1-w-full l1-flex-col l1-gap-4 ${flowType === "EDIT_PROFILE" ? "" : flowType === "PROFILE_NUDGE" ? "l1-mb-36 md:l1-mb-12" : "l1-mb-36 l1-mt-10 md:l1-mb-12 md:l1-mt-9"}`}
        id="basicDetailsForm"
        onSubmit={handleSubmit(onSubmitWrapper)}
        noValidate
      >
        {flowType !== "EDIT_PROFILE" && flowType !== "PROFILE_NUDGE" && (
          <p className="l1-text-xs l1-text-gray-400">
            Help us understand you better
          </p>
        )}

        <div className="l1-flex l1-flex-col l1-gap-4">
          {flowType !== "EDIT_PROFILE" &&
          flowType !== "PROFILE_NUDGE" &&
          showLinkedinURL ? (
            <LinkedinURL
              register={register}
              setValue={setValue}
              errors={errors}
              setError={setError}
              clearError={() => clearErrors("linkedin")}
            />
          ) : null}

          <Label labelText="Name" isRequired={true} className="!l1-text-sm">
            <Input
              id="name"
              placeholder="Enter your name"
              {...register("name", {
                required: "This field is required",
                onBlur: (event) => {
                  setValue("name", event.target.value.trim());
                },
                pattern: {
                  value: ALPAHBET_REGEX,
                  message: "Invalid name",
                },
              })}
              maxLength={30}
              errorText={errors.name ? errors?.name?.message : ""}
            />
          </Label>

          {flowType !== "EDIT_PROFILE" &&
          flowType !== "PROFILE_NUDGE" &&
          siteConfig?.site_map !== "monstersingapore" ? (
            <Label labelText="Gender" isRequired={true} className="!l1-text-sm">
              <PillController
                name="gender"
                size="medium"
                selectType="single"
                control={control}
                options={genderOptions ?? []}
                isRequired={true}
                onSelect={(selected: DropdownOptionType[]) => {
                  clearErrors("gender");
                  setValue("gender", selected[0]);
                }}
                errorMessage={errors.gender ? "This field is required" : ""}
              />
            </Label>
          ) : null}

          {flowType !== "PROFILE_NUDGE" ? (
            <Label
              labelText="Enter Total Experience"
              isRequired={true}
              className="!l1-text-sm"
            >
              <div className="l1-flex l1-flex-row l1-gap-2">
                <SingleDropDownController
                  name="years"
                  control={control}
                  isRequired={true}
                  placeholder="Years"
                  isSearchable={false}
                  options={ExperienceYearsDropdownOptionsData}
                  onSelect={(selected: DropdownOptionType) => {
                    clearErrors("years");
                  }}
                  errorMessage={errors.years ? "This field is required" : ""}
                />

                <SingleDropDownController
                  name="months"
                  control={control}
                  isRequired={true}
                  placeholder="Months"
                  isSearchable={false}
                  options={ExperienceMonthsDropdownOptionsData}
                  onSelect={(selected: DropdownOptionType) => {
                    clearErrors("months");
                  }}
                  errorMessage={errors.months ? "This field is required" : ""}
                />
              </div>
            </Label>
          ) : null}

          <Label
            labelText="Current Location"
            isRequired={true}
            className="!l1-text-sm"
          >
            <SingleDropDownController
              name="city"
              control={control}
              isRequired={true}
              placeholder="City"
              isSearchable={true}
              options={cityData ?? []}
              isLoading={isDropdownOptionLoading}
              onChangeHandler={(value: string) => {
                cityDropdownOptionsData(value);
              }}
              onSelect={(selected: CityDropdownType) => {
                clearErrors("city");
                setValue("city", selected);
                setCountryIsoCode(selected?.countryIsoCode ?? "IN");
                setCountry(selected?.country ?? "");

                const isOther = selected && selected?.text.includes("Other");
                if (isOther) {
                  setIsOtherCity(true);
                } else {
                  setIsOtherCity(false);
                }

                if (
                  selected &&
                  selected?.country &&
                  selected?.country !== "India"
                ) {
                  setIsCityOtherThenIndia(true);
                } else {
                  setIsCityOtherThenIndia(false);
                  setShowWorkAuthorization(false);
                }
                setValue("nationality", null);
                setValue("workAuthorization", null);
              }}
              errorMessage={errors.city ? "This field is required" : ""}
            />
          </Label>

          {isOtherCity ? (
            <Label
              labelText="Enter your City Name"
              isRequired={true}
              className="!l1-text-sm"
            >
              <Input
                id="otherCity"
                placeholder="Enter your city name"
                {...register("otherCity", {
                  required: "This field is required",
                  pattern: {
                    value: ALPAHBET_REGEX,
                    message: "Invalid city name",
                  },
                })}
                errorText={errors.otherCity ? errors?.otherCity?.message : ""}
              />
            </Label>
          ) : null}

          {siteConfig?.site_map !== "rexmonster" || isCityOtherThenIndia ? (
            <Label
              labelText="Nationality"
              isRequired={true}
              className="!l1-text-sm"
            >
              <SingleDropDownController
                name="nationality"
                control={control}
                isRequired={true}
                placeholder="Select Your Nationality"
                isSearchable={true}
                options={nationalityData ?? []}
                isLoading={isDropdownOptionLoading}
                onChangeHandler={(value: string) => {
                  nationalityDropdownOptionsData(value);
                }}
                onSelect={(selected: NationalityDropdownType) => {
                  clearErrors("nationality");
                  if (
                    selected?.countryUUID &&
                    selected?.countryUUID !== getValues("city")?.countryUUID
                  ) {
                    setShowWorkAuthorization(true);
                  } else {
                    setShowWorkAuthorization(false);
                  }
                  setValue("workAuthorization", null);
                }}
                errorMessage={
                  errors.nationality ? "This field is required" : ""
                }
              />
            </Label>
          ) : null}

          {showWorkAuthorization ? (
            <Label
              labelText={`Work authorization for ${country}`}
              isRequired={true}
              className="!l1-text-sm"
            >
              <SingleDropDownController
                name="workAuthorization"
                control={control}
                isRequired={true}
                placeholder="Select your work authorization"
                isSearchable={false}
                options={workAuthorizationData ?? []}
                onSelect={(selected: DropdownOptionType) => {
                  clearErrors("workAuthorization");
                  setValue("workAuthorization", selected);
                }}
                errorMessage={
                  errors.workAuthorization ? "This field is required" : ""
                }
              />
            </Label>
          ) : null}

          {siteConfig?.site_map !== "rexmonster" && !hasPrefilledLanguages ? (
            <LanguageCardContainer
              languageDataArray={languageData}
              control={control}
              clearErrors={clearErrors}
              errors={errors}
              setValue={setValue}
              addAnotherLanguageDataHandler={addAnotherLanguageDataHandler}
              deleteLanguageDataHandler={deleteLanguageDataHandler}
            />
          ) : null}

          {/* {flowType !== "EDIT_PROFILE" &&
          flowType !== "PROFILE_NUDGE" &&
          showLinkedinConsent ? (
            <LinkedInConsent
              checked={isAutoUpdateChecked}
              handleConsentToggle={(e: React.ChangeEvent<HTMLInputElement>) => {
                setValue("isToggled", e.target.checked);
                setIsAutoUpdateChecked(e.target.checked);
              }}
            />
          ) : null} */}
        </div>

        {flowType === "EDIT_PROFILE" ? (
          <ActionButtonContainer
            primaryBtnLabel="Save"
            secondaryBtnLabel="Cancel"
            secondaryBtnOnClick={backBtnClickHandler}
            isLoading={isSubmitAPILoading}
          />
        ) : (
          <>
            {flowType === "PROFILE_NUDGE" ? (
              <ActionButtonContainer
                primaryBtnLabel="Confim & Apply"
                isLoading={isSubmitAPILoading}
              />
            ) : (
              <ActionButtonContainer
                primaryBtnLabel="Save"
                isLoading={isSubmitAPILoading}
              />
            )}
          </>
        )}
      </form>
    </>
  );
};
